// import Competitions from "./Competitions";
// import ContactUs from "./ContactUs";
// import Apps from "./Apps";
// import FreeBets from "./FreeBets";
// import HelpCentre from "./HelpCentre";
// import Horse from "./Horse/Horse";
// import IndividualCompetition from "./IndividualCompetition";
// import Jockey from "./Jockey";
// import Podcasts from "./Podcasts";
// import PrivacyPolicy from "./PrivacyPolicy";
// import Racecourses from "./Racecourses/Racecourses";
// import Racecourse from "./Racecourses/Racecourse";
// import RacecourseOffers from "./RacecourseOffers";
// import ResponsibleGambling from "./ResponsibleGambling";
// import Rewards4Racing from "./Rewards4Racing";
// import Syndicate from "./Syndicate";
// import Search from "./Search";
// import TermsAndConditions from "./TermsAndConditions";
// import Trainer from "./Trainer";
// import RMGPressRelease from "./RMGPressRelease";
// import NotFound from "./NotFound";
// import TodaysRunners from "./TodaysRunners";
// import TomorrowsRunners from "./TomorrowsRunners";
// import General from "./HelpCentre/General";
// import Sky from "./HelpCentre/Sky";
// import Online from "./HelpCentre/Online";
// import Extra from "./HelpCentre/Extra";
// import IOS from "./HelpCentre/IOS";
// import Virgin from "./HelpCentre/Virgin";
// import Vodafone from "./HelpCentre/Vodafone";
// import DayPass from "./HelpCentre/DayPass";
// import International from "./HelpCentre/International";
// import Mobile from "./HelpCentre/Mobile";
// import ClubDaysHelp from "./HelpCentre/ClubDaysHelp";
// import Android from "./HelpCentre/Android";
// import Freeview from "./HelpCentre/Freeview";
// import HorseRacingCalendar from "./HorseRacingCalendar";
// import Profiles from "./Profiles/Profiles";
// import IndexOrProfile from "./Profiles/IndexOrProfile";
// import FestivalHub from "./Festivals/FestivalHub";

// lazyImport the above imports

import lazyImport from "../../../utils/lazyImport/lazyImport";

// lazyImport the above imports
const Competitions = lazyImport(() => import("./Competitions"));
const ContactUs = lazyImport(() => import("./ContactUs"));
const Apps = lazyImport(() => import("./Apps"));
const FreeBets = lazyImport(() => import("./FreeBets"));
const HelpCentre = lazyImport(() => import("./HelpCentre"));
const Horse = lazyImport(() => import("./Horse/Horse"));
const IndividualCompetition = lazyImport(
  () => import("./IndividualCompetition")
);
const Jockey = lazyImport(() => import("./Jockey"));
const Podcasts = lazyImport(() => import("./Podcasts"));
const PrivacyPolicy = lazyImport(() => import("./PrivacyPolicy"));
const Racecourse = lazyImport(() => import("./Racecourses/Racecourse"));
const Racecourses = lazyImport(() => import("./Racecourses/Racecourses"));
const RacecourseOffers = lazyImport(() => import("./RacecourseOffers"));
const ResponsibleGambling = lazyImport(() => import("./ResponsibleGambling"));
const Rewards4Racing = lazyImport(() => import("./Rewards4Racing"));
const Syndicate = lazyImport(() => import("./Syndicate"));
const Search = lazyImport(() => import("./Search"));
const TermsAndConditions = lazyImport(() => import("./TermsAndConditions"));
const Trainer = lazyImport(() => import("./Trainer"));
const RMGPressRelease = lazyImport(() => import("./RMGPressRelease"));
const NotFound = lazyImport(() => import("./NotFound"));
const TodaysRunners = lazyImport(() => import("./TodaysRunners"));
const TomorrowsRunners = lazyImport(() => import("./TomorrowsRunners"));
const General = lazyImport(() => import("./HelpCentre/General"));
const Sky = lazyImport(() => import("./HelpCentre/Sky"));
const Online = lazyImport(() => import("./HelpCentre/Online"));
const Extra = lazyImport(() => import("./HelpCentre/Extra"));
const IOS = lazyImport(() => import("./HelpCentre/IOS"));
const Virgin = lazyImport(() => import("./HelpCentre/Virgin"));
const Vodafone = lazyImport(() => import("./HelpCentre/Vodafone"));
const DayPass = lazyImport(() => import("./HelpCentre/DayPass"));
const International = lazyImport(() => import("./HelpCentre/International"));
const Mobile = lazyImport(() => import("./HelpCentre/Mobile"));
const ClubDaysHelp = lazyImport(() => import("./HelpCentre/ClubDaysHelp"));
const Android = lazyImport(() => import("./HelpCentre/Android"));
const Freeview = lazyImport(() => import("./HelpCentre/Freeview"));
const HorseRacingCalendar = lazyImport(() => import("./HorseRacingCalendar"));
const Profiles = lazyImport(() => import("./Profiles/Profiles"));
const IndexOrProfile = lazyImport(() => import("./Profiles/IndexOrProfile"));
const FestivalHub = lazyImport(() => import("./Festivals/FestivalHub"));
const BasicChart = lazyImport(() => import("./../Charts/BasicChart"));
const SparklineChart = lazyImport(() => import("./../Charts/SparklineChart"));
const CmsContentTypes = lazyImport(() => import("./CmsContentTypes"));

export default {
  Competitions,
  ContactUs,
  Apps,
  FreeBets,
  HelpCentre,
  Horse,
  IndividualCompetition,
  Jockey,
  Podcasts,
  PrivacyPolicy,
  Racecourse,
  Racecourses,
  RacecourseOffers,
  ResponsibleGambling,
  Rewards4Racing,
  Syndicate,
  Search,
  TermsAndConditions,
  Trainer,
  RMGPressRelease,
  NotFound,
  TodaysRunners,
  TomorrowsRunners,
  General,
  Sky,
  Online,
  Extra,
  IOS,
  Virgin,
  Vodafone,
  DayPass,
  International,
  Mobile,
  ClubDaysHelp,
  Android,
  Freeview,
  HorseRacingCalendar,
  Profiles,
  IndexOrProfile,
  FestivalHub,
  BasicChart,
  SparklineChart,
  CmsContentTypes,
};
